import { Collapse } from "antd";
import arrowDown from "../assets/arrow-down.svg";

const { Panel } = Collapse;

const EQ_INTRO_TEXT =
  "Din totala EQ-poäng ger en övergripande bild av din emotionella intelligens. EQ- poängen har ett medelvärde runt 100 för den svenska befolkningen.";
const EQ_PROMPT_TEXT = "Om din poäng är:";
const EQ_ITEMS = [
  "Under 90: Detta kan indikera att du har vissa utmaningar med att hantera känslor och reaktioner, men det är också en möjlighet att utveckla dessa förmågor med medveten träning och självreflektion.",
  "Runt 100: Din emotionella intelligens ligger på en genomsnittlig nivå, vilket tyder på att du har en god förståelse för och hantering av känslor i många situationer.",
  "Över 110: Detta innebär att du har en välutvecklad förmåga att förstå, hantera och använda känslor vilket ofta gynnar både dig själv och dina relationer.",
];
const EQ_COMPONENTS_TEXT =
  "De olika komponenterna – stresshantering, motivation och empati – kan dock variera inom din totala EQ. Detta betyder att även om din totala EQ-poäng är högre än 100, genomsnittlig eller lägre än 100, kan du ha särskilda styrkor eller förbättringspotential inom enskilda delar.";
const EQ_EXAMPLE_TEXT =
  'Till exempel kan du ha en stark förmåga att motivera dig själv och sätta långsiktiga mål, men samtidigt uppleva utmaningar med att hantera stress. Att förstå hur varje komponent bidrar till din totala EQ hjälper dig att identifiera var du kan bygga vidare på styrkor och utveckla nya strategier för att hantera utmaningar se nedan mer detaljerad förklaring.';

const HurSection = () => {
  return (
    <div className="font-nunito w-full h-full  bg-primary-card rounded-lg p-2 text-start">
      <Collapse
        expandIconPosition="right"
        className="text-white border-none bg-transparent border-[#3F51B5]"
        expandIcon={({ isActive }) => (
          <div className="w-[56px] h-[56px] p-3 bg-[#3F51B5] rounded-xl flex items-center justify-center">
            <img
              src={arrowDown}
              alt="arrow"
              className={`transition-transform duration-300 ${
                isActive ? "transform rotate-180" : ""
              }`}
            />
          </div>
        )}
      >
        <Panel
          header={
            <span className="text-2xl md:text-3xl text-white">
              Hur använder jag mitt EQ-resultat - allmänt
            </span>
          }
          key={"hur-section"}
          className="p-0"
        >
          <p className="faq-answer text-base text-white bg-primary-card">
            {EQ_INTRO_TEXT}
          </p>
          <p className="faq-answer text-base text-white bg-primary-card">
            {EQ_PROMPT_TEXT}
          </p>
          <div className="font-nunito text-white bg-primary-card p-8 rounded-lg">
            <ul className="list-disc pl-2">
              {EQ_ITEMS.map((item, index) => (
                <li key={index} className="text-base mb-2">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <p className="faq-answer text-base text-white bg-primary-card">
            {EQ_COMPONENTS_TEXT}
          </p>
          <p className="faq-answer text-base text-white bg-primary-card">
            {EQ_EXAMPLE_TEXT}
          </p>
        </Panel>
      </Collapse>
    </div>
  );
};

export default HurSection;
